<template>
  <div class="card-manage-container">
    <el-card class="card-manage-card">
      <h2 class="card-manage-title">卡密管理</h2>
      <el-form :inline="true" :model="searchForm" @submit.native.prevent="onSearch" :label-position="isMobile ? 'top' : 'right'">
        <el-form-item label="VIP类型">
          <el-select v-model="searchForm.vip_type" placeholder="全部" clearable style="width: 120px">
            <el-option label="全部" value="" />
            <el-option label="周卡" value="week" />
            <el-option label="月卡" value="month" />
            <el-option label="季卡" value="quarter" />
            <el-option label="年卡" value="year" />
            <el-option label="永久卡" value="forever" />
          </el-select>
        </el-form-item>
        <el-form-item label="使用状态">
          <el-select v-model="searchForm.is_used" placeholder="全部" clearable style="width: 120px">
            <el-option label="全部" value="" />
            <el-option label="未使用" :value="0" />
            <el-option label="已使用" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item label="卡密">
          <el-input v-model="searchForm.card_code" placeholder="请输入卡密/卡号" clearable style="width: 180px" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch" :loading="loading">搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
          <el-button type="success" @click="showAddDialog">新增卡密</el-button>
        </el-form-item>
      </el-form>
      <!-- PC端表格 -->
      <el-table v-if="!isMobile" :data="cards" border stripe style="width: 100%" v-loading="loading">
        <el-table-column prop="card_code" label="卡密" min-width="200">
          <template slot-scope="scope">
            <el-input v-model="scope.row.card_code" readonly size="mini" style="width: 90%" />
            <el-button type="text" size="mini" @click="copyCard(scope.row.card_code)">复制</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="vip_type" label="VIP类型" width="100">
          <template slot-scope="scope">
            <span :class="['tag-label', getVipTagClass(scope.row.vip_type)]">
              {{ getVipTypeText(scope.row.vip_type) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="is_used" label="使用状态" width="100">
          <template slot-scope="scope">
            <span :class="['tag-label', getCardStatusTagClass(scope.row.is_used)]">
              {{ scope.row.is_used ? '已使用' : '未使用' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.create_time) }}
          </template>
        </el-table-column>
        <el-table-column prop="used_time" label="使用时间" width="180">
          <template slot-scope="scope">
            {{ scope.row.used_time ? formatDate(scope.row.used_time) : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="used_by_username" label="使用者" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.is_used && scope.row.used_by_username">
              <div class="user-info">
                <el-tag size="mini" type="success">{{ scope.row.used_by_username }}</el-tag>
              </div>
              <div class="user-email" v-if="scope.row.used_by_email">
                <small style="color: #909399;">{{ scope.row.used_by_email }}</small>
              </div>
            </div>
            <span v-else style="color: #c0c4cc;">-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <div class="action-buttons">
              <el-button 
                type="danger" 
                size="mini" 
                icon="el-icon-delete"
                @click="onDelete(scope.row)"
              >
                删除
              </el-button>
              <el-button 
                type="warning" 
                size="mini" 
                icon="el-icon-edit"
                @click="onUpdate(scope.row)"
              >
                修改
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 移动端卡片列表 -->
      <div v-else class="mobile-card-list">
        <div v-for="item in cards" :key="item.card_code" class="mobile-card">
          <div class="mobile-card-title">卡密: {{ item.card_code }}</div>
          <div class="mobile-card-row">VIP类型：<span :class="['tag-label', getVipTagClass(item.vip_type)]">{{ getVipTypeText(item.vip_type) }}</span></div>
          <div class="mobile-card-row">使用状态：<span :class="['tag-label', getCardStatusTagClass(item.is_used)]">{{ item.is_used ? '已使用' : '未使用' }}</span></div>
          <div class="mobile-card-row">创建时间：{{ formatDate(item.create_time) }}</div>
          <div class="mobile-card-row">使用时间：{{ item.used_time ? formatDate(item.used_time) : '-' }}</div>
          <div class="mobile-card-row">使用者：<span v-if="item.is_used && item.used_by_username"><el-tag size="mini" type="success">{{ item.used_by_username }}</el-tag></span><span v-else style="color: #c0c4cc;">-</span></div>
          <div class="mobile-card-actions">
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="onDelete(item)">删除</el-button>
            <el-button type="warning" size="mini" icon="el-icon-edit" @click="onUpdate(item)">修改</el-button>
          </div>
        </div>
        <div v-if="!cards.length && !loading" class="no-data-tip">暂无数据</div>
      </div>
      <div style="margin: 16px 0; text-align: right">
        <el-pagination
          background
          layout="prev, pager, next, jumper"
          :current-page="searchForm.page"
          :page-size="searchForm.pageSize"
          :total="total"
          @current-change="onPageChange"
        />
      </div>
    </el-card>
    <!-- 修改卡密对话框 -->
    <el-dialog title="修改卡密" :visible.sync="dialogVisible" width="500px">
      <el-form :model="editForm" label-width="100px">
        <el-form-item label="卡密">
          <el-input v-model="editForm.card_code" readonly />
        </el-form-item>
        <el-form-item label="VIP类型">
          <el-select v-model="editForm.vip_type" placeholder="请选择VIP类型">
            <el-option label="周卡" value="week" />
            <el-option label="月卡" value="month" />
            <el-option label="季卡" value="quarter" />
            <el-option label="年卡" value="year" />
            <el-option label="永久卡" value="forever" />
          </el-select>
        </el-form-item>
        <el-form-item label="使用状态">
          <el-select v-model="editForm.is_used" placeholder="请选择状态">
            <el-option label="未使用" :value="0" />
            <el-option label="已使用" :value="1" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmUpdate" :loading="updating">确定</el-button>
      </div>
    </el-dialog>

    <!-- 新增卡密对话框 -->
    <el-dialog title="新增卡密" :visible.sync="addDialogVisible" width="600px">
      <el-form :model="addForm" :rules="addRules" ref="addForm" label-width="100px">
        <el-form-item label="VIP类型" prop="vip_type">
          <el-select v-model="addForm.vip_type" placeholder="请选择VIP类型" style="width: 100%">
            <el-option label="周卡" value="week" />
            <el-option label="月卡" value="month" />
            <el-option label="季卡" value="quarter" />
            <el-option label="年卡" value="year" />
            <el-option label="永久卡" value="forever" />
          </el-select>
        </el-form-item>
        <el-form-item label="生成数量" prop="count">
          <el-input-number 
            v-model="addForm.count" 
            :min="1" 
            :max="100" 
            :step="1"
            style="width: 100%"
            placeholder="请输入生成数量（1-100）"
          />
          <div class="form-tip">最多可生成100个卡密</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmAdd" :loading="adding">生成卡密</el-button>
      </div>
    </el-dialog>

    <!-- 生成结果对话框 -->
    <el-dialog title="卡密生成成功" :visible.sync="resultDialogVisible" width="700px">
      <div class="result-content">
        <div class="result-header">
          <el-alert
            title="卡密生成成功"
            type="success"
            :closable="false"
            show-icon
          >
            <template slot="title">
              成功生成 {{ generatedCards.length }} 个卡密
            </template>
          </el-alert>
        </div>
        <div class="result-actions">
          <el-button type="primary" icon="el-icon-document-copy" @click="copyAllCards">
            复制全部卡密
          </el-button>
          <el-button type="success" icon="el-icon-download" @click="downloadCards">
            下载卡密文件
          </el-button>
        </div>
        <div class="cards-list">
          <div class="cards-header">
            <span>生成的卡密列表：</span>
          </div>
          <div class="cards-container">
            <div 
              v-for="(card, index) in generatedCards" 
              :key="index" 
              class="card-item"
            >
              <span class="card-code">{{ card.card_code }}</span>
              <el-tag size="mini" :type="getVipTypeColor(card.vip_type)">
                {{ getVipTypeText(card.vip_type) }}
              </el-tag>
              <el-button 
                type="text" 
                size="mini" 
                icon="el-icon-copy"
                @click="copySingleCard(card.card_code)"
              >
                复制
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resultDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'CardManage',
  data() {
    return {
      searchForm: {
        card_code: '',
        vip_type: '',
        is_used: '',
        page: 1,
        pageSize: 20
      },
      cards: [],
      total: 0,
      loading: false,
      dialogVisible: false,
      updating: false,
      addDialogVisible: false,
      resultDialogVisible: false,
      adding: false,
      editForm: {
        card_code: '',
        vip_type: '',
        is_used: 0
      },
      addForm: {
        vip_type: '',
        count: 1
      },
      addRules: {
        vip_type: [{ required: true, message: '请选择VIP类型', trigger: 'change' }],
        count: [
          { required: true, message: '请输入生成数量', trigger: 'blur' },
          { type: 'number', min: 1, max: 100, message: '生成数量必须在1-100之间', trigger: 'blur' }
        ]
      },
      generatedCards: [],
      isMobile: false
    }
  },
  created() {
    this.fetchCards();
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  destroyed() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() { this.isMobile = window.innerWidth < 768; },
    async fetchCards() {
      this.loading = true;
      try {
        const params = {
          page: this.searchForm.page,
          pageSize: this.searchForm.pageSize,
          vip_type: this.searchForm.vip_type,
          is_used: this.searchForm.is_used,
          card_code: this.searchForm.card_code
        };
        const res = await this.$axios.get('/user/card/list', { params });
        if (res && res.code === 200) {
          this.cards = res.data;
          this.total = res.total;
        } else {
          this.$message.error(res.message || '获取卡密列表失败');
        }
      } catch (e) {
        this.$message.error(e.response?.data?.message || '网络错误');
      } finally {
        this.loading = false;
      }
    },
    onSearch() {
      this.searchForm.page = 1;
      this.fetchCards();
    },
    resetSearch() {
      this.searchForm = {
        card_code: '',
        vip_type: '',
        is_used: '',
        page: 1,
        pageSize: 20
      };
      this.fetchCards();
    },
    onPageChange(page) {
      this.searchForm.page = page;
      this.fetchCards();
    },
    async onDelete(row) {
      try {
        await this.$confirm('确定要删除这个卡密吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        const res = await this.$axios.post('/user/card/delete', { card_code: row.card_code });
        if (res && res.code === 200) {
          this.$message.success('删除成功');
          this.fetchCards();
        } else {
          this.$message.error(res.message || '删除失败');
        }
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error(e.response?.data?.message || '网络错误');
        }
      }
    },
    onUpdate(row) {
      this.editForm = {
        card_code: row.card_code,
        vip_type: row.vip_type,
        is_used: row.is_used
      };
      this.dialogVisible = true;
    },
    async confirmUpdate() {
      this.updating = true;
      try {
        const res = await this.$axios.post('/user/card/update', this.editForm);
        if (res && res.code === 200) {
          this.$message.success('修改成功');
          this.dialogVisible = false;
          this.fetchCards();
        } else {
          this.$message.error(res.message || '修改失败');
        }
      } catch (e) {
        this.$message.error(e.response?.data?.message || '网络错误');
      } finally {
        this.updating = false;
      }
    },
    copyCard(cardCode) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(cardCode).then(() => {
          this.$message.success('已复制到剪贴板');
        });
      } else {
        const input = document.createElement('input');
        input.value = cardCode;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        this.$message.success('已复制到剪贴板');
      }
    },
    getVipTypeText(type) {
      const types = { week: '周卡', month: '月卡', quarter: '季卡', year: '年卡', forever: '永久卡' };
      return types[type] || type;
    },
    getVipTypeColor(type) {
      const colors = { week: 'info', month: 'success', quarter: 'warning', year: 'danger', forever: 'primary' };
      return colors[type] || 'info';
    },
    getVipTagClass(type) {
      const map = {
        'week': 'tag-vip-week',
        'month': 'tag-vip-month',
        'quarter': 'tag-vip-season',
        'year': 'tag-vip-year',
        'forever': 'tag-vip-forever'
      };
      return map[type] || 'tag-vip-week';
    },
    getCardStatusTagClass(isUsed) {
      return isUsed ? 'tag-status-used' : 'tag-status-unused';
    },
    formatDate(val) {
      if (!val) return '';
      const d = new Date(val);
      const pad = n => n.toString().padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    showAddDialog() {
      this.addForm = {
        vip_type: '',
        count: 1
      };
      this.addDialogVisible = true;
    },
    async confirmAdd() {
      this.$refs.addForm.validate(async valid => {
        if (!valid) return;
        this.adding = true;
        try {
          const res = await this.$axios.post('/user/gen_card', this.addForm);
          if (res && res.code === 200) {
            this.generatedCards = res.cards.map(card_code => ({
              card_code,
              vip_type: this.addForm.vip_type
            }));
            this.addDialogVisible = false;
            this.resultDialogVisible = true;
            this.fetchCards(); // 刷新列表
          } else {
            this.$message.error(res.message || '生成卡密失败');
          }
        } catch (e) {
          this.$message.error(e.response?.data?.message || '网络错误');
        } finally {
          this.adding = false;
        }
      });
    },
    copyAllCards() {
      const cardText = this.generatedCards.map(card => card.card_code).join('\n');
      this.copyToClipboard(cardText, '已复制全部卡密到剪贴板');
    },
    copySingleCard(cardCode) {
      this.copyToClipboard(cardCode, '已复制卡密到剪贴板');
    },
    copyToClipboard(text, message) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success(message);
        }).catch(() => {
          this.fallbackCopy(text, message);
        });
      } else {
        this.fallbackCopy(text, message);
      }
    },
    fallbackCopy(text, message) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        this.$message.success(message);
      } catch (err) {
        this.$message.error('复制失败');
      }
      document.body.removeChild(textArea);
    },
    downloadCards() {
      const cardText = this.generatedCards.map(card => card.card_code).join('\n');
      const blob = new Blob([cardText], { type: 'text/plain' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `卡密_${this.addForm.vip_type}_${new Date().toISOString().slice(0, 10)}.txt`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      this.$message.success('文件下载成功');
    }
  }
}
</script>

<style scoped>
.card-manage-container {
  max-width: 1200px;
  margin: 32px auto;
}
.card-manage-card {
  padding: 24px 24px 8px 24px;
}
.card-manage-title {
  text-align: center;
  margin-bottom: 24px;
  font-weight: 500;
}

/* 标签样式 */
.tag-vip-week {
  background-color: #909399;
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
}
.tag-vip-month {
  background-color: #67c23a;
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
}
.tag-vip-season {
  background-color: #e6a23c;
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
}
.tag-vip-year {
  background-color: #f56c6c;
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
}
.tag-vip-forever {
  background-color: #409eff;
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: bold;
}
.tag-status-used {
  background-color: #909399;
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
}
.tag-status-unused {
  background-color: #67c23a;
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
}

/* 操作按钮样式 */
.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
}

.action-buttons .el-button {
  width: 100%;
  margin: 0;
  justify-content: center;
}

/* 表单提示 */
.form-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

/* 结果对话框样式 */
.result-content {
  padding: 16px 0;
}

.result-header {
  margin-bottom: 20px;
}

.result-actions {
  margin-bottom: 20px;
  display: flex;
  gap: 12px;
}

.cards-list {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 16px;
  background: #fafafa;
}

.cards-header {
  margin-bottom: 12px;
  font-weight: 500;
  color: #606266;
}

.cards-container {
  max-height: 300px;
  overflow-y: auto;
}

.card-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  margin-bottom: 8px;
  background: white;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.card-item:hover {
  border-color: #409eff;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.1);
}

.card-code {
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 14px;
  color: #303133;
  flex: 1;
  margin-right: 12px;
}

/* 使用者信息样式 */
.user-info {
  margin-bottom: 4px;
}

.user-email {
  font-size: 11px;
  line-height: 1.2;
}

/* 动画效果 */
.el-button {
  transition: all 0.3s ease;
}

.el-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

@media (max-width: 768px) {
  .card-manage-container {
    padding: 4px;
  }
  .card-manage-title {
    font-size: 1.1rem;
    margin-bottom: 12px;
  }
  .el-form {
    flex-direction: column !important;
    align-items: stretch !important;
    display: flex !important;
  }
  .el-form-item {
    margin-bottom: 8px;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .el-input,
  .el-select,
  .el-button {
    width: 100% !important;
    min-width: 0 !important;
    box-sizing: border-box;
  }
  .mobile-card-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 0 0 12px 0;
  }
  .mobile-card {
    background: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    padding: 14px 12px 10px 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .mobile-card-title {
    font-weight: 600;
    font-size: 15px;
    color: #333;
    margin-bottom: 2px;
    word-break: break-all;
  }
  .mobile-card-row {
    font-size: 13px;
    margin-bottom: 2px;
    word-break: break-all;
  }
  .mobile-card-actions {
    display: flex;
    gap: 8px;
    margin-top: 4px;
  }
}
@media (min-width: 768px) {
  .mobile-card-list { display: none; }
}
</style> 